<template>
	<div>
		<p v-if="emailSubmitted" class="ui-body" v-html="registerSuccessBody"></p>

		<div v-else-if="userExists">
			<h4>Your email address is already registered</h4>
			<p>Click <router-link :to="{name: 'Login'}">here</router-link> to login or reset your password.</p>
		</div>

		<template v-else>
			<p class="ui-title">{{ registerHeading }}</p>
			<p class="ui-body" v-html="registerBodyComputed"></p>

			<ui-form
				:is-processing="isProcessing"
				:valid.sync="formValid"
				@submit="register"
			>
				<ui-input
					v-if="!params.token"
					v-model="email"
					label="E-mail"
					required
					type="email"
				/>
				<ui-input
					v-if="partner || (params.token && !params.fname)"
					v-model="firstName"
					label="First name"
					:required="params.token"
					type="text"
				/>
				<ui-input
					v-if="partner || (params.token && !params.lname)"
					v-model="lastName"
					label="Last name"
					:required="params.token"
					type="text"
				/>
				<ui-input
					v-if="params.token"
					v-model="password"
					autocomplete="new-password"
					label="Password"
					minlength="8"
					required
					type="password"
				/>
				<ui-input
					v-if="params.token"
					v-model="verifyPassword"
					:error="passwordMatch"
					autocomplete="new-password"
					label="Verify password"
					required
					type="password"
				/>
				<ui-input
					v-if="partner || (params.token && !params.company_name)"
					v-model="companyName"
					label="Company"
					:required="params.token"
					type="text"
				/>
				<ui-select
					v-if="partner || (params.token && !params.pop_id)"
					v-model="popId"
					label="Recorder/storage location"
					:required="params.token"
				>
					<ui-select-item
						v-for="(val, key) in popIdList"
						:key="key"
						:label="val"
						:value="key"
					/>
				</ui-select>
				<div class="ui-layout ui-alignment-center-space-between">
					<div v-if="privacyUrl">Your privacy is important to us. By submitting your information you are agreeing to our <a :href="privacyUrl" target="_blank">Privacy notice</a>.</div>
					<router-link :to="{name: 'Login'}">Already registered? Login</router-link>
					<ui-button
						:disabled="!formValid || isProcessing"
						primary
						raised
						text="Register"
						type="submit"
					/>
				</div>
			</ui-form>
		</template>
	</div>
</template>

<script>
import UiButton from "lib/components/ui/Button";
import UiForm from "lib/components/ui/Form";
import UiInput from "lib/components/ui/Input";
import UiSelect from "lib/components/ui/Select";
import UiSelectItem from "lib/components/ui/SelectItem";
import alert from "lib/modules/Alert";
import auth from "lib/modules/Auth";
import http from "lib/modules/Http";

export default {
	name: "Register",
	components: {
		UiButton,
		UiForm,
		UiInput,
		UiSelect,
		UiSelectItem
	},
	props: {
		params: {
			type: Object,
			required: true
		},
		partner: {
			type: Boolean,
			required: true
		},
		privacyUrl: {
			type: String,
			required: true
		},
		registerBody: {
			type: String,
			required: true
		},
		registerHeading: {
			type: String,
			required: true
		},
		registerSuccessBody: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			formValid: false,
			isProcessing: false,
			companyName: "",
			email: "",
			firstName: "",
			lastName: "",
			password: "",
			verifyPassword: "",
			popId: "",
			popIdList: {
				osl: "Oslo (Norway)"
			},
			emailSubmitted: false,
			userExists: false
		};
	},
	computed: {
		passwordMatch() {
			if (this.password !== this.verifyPassword)
				return "Passwords do not match";

			return null;
		},
		registerBodyComputed() {
			const partner = this.partner || (this.params.token && this.params.company_name) ? 1 : 0;
			const query = `[ng-show="regStep==${this.params.token ? 2 : 1} && partner==${partner}"]`;
			const div = document.createElement("div");

			div.innerHTML = this.registerBody;

			const el = div.querySelector(query);
			if (!el)
				return "";

			el.removeAttribute("ng-show");

			return el.outerHTML;
		}
	},
	mounted() {
		this.companyName = this.params.company_name || "";
		this.firstName = this.params.fname || "";
		this.lastName = this.params.lname || "";
		this.popId = this.params.pop_id || "";

		this.$nextTick(() => this.$el.querySelector("input").focus());

		if (this.params.token)
			this.register(false);
	},
	methods: {
		register(showAlert=true) {
			this.isProcessing = true;

			http.post("/api/v2/register", {
				...!this.params.token && { email: this.email },
				...this.params.token && { token: this.params.token },
				...this.companyName && { company_name: this.companyName },
				...this.firstName && { fname: this.firstName },
				...this.lastName && { lname: this.lastName },
				...this.password && { password: this.password },
				...this.popId && { pop_id: this.popId }
			})
			.then((resp) => {
				if (this.params.token)
					return this.login(resp.data.email);

				this.emailSubmitted = true;

				return true;
			})
			.catch((error) => {
				if (this.params.token && error.response && error.response.status === 403)
					this.userExists = true;
				else if (showAlert)
					alert.error("Registration failed", error.response);
			})
			.finally(() => {
				this.isProcessing = false;
			});
		},
		login(email) {
			return auth.login(email, this.password).then(() => {
				location.href = location.origin + "/";
			})
			.catch((error) => {
				alert.error("Authentication error", error.response);
				this.$router.push({ name: "Login" });
			});
		}
	}
};
</script>
